import RequireAuth from '../components/routing/RequireAuth';
import { AUTH_TYPE } from '../constants/auth';
import AlbumFolderLinkRequestRedirect from '../apps/pro/views/AlbumFolderLinkRequestRedirect';
import PurchasedEventRedirect from '../apps/pro/views/PurchasedEventRedirect/PurchasedEventRedirect';

const routes = [
  {
    path: `/glink/:albumFolderLinkRequestId/:status(accept|reject)`,
    exact: true,
    component: RequireAuth(AlbumFolderLinkRequestRedirect, {
      authType: AUTH_TYPE.EMAIL,
    }),
  },
  {
    path: `/purchased-events/:purchasedEventId`,
    exact: true,
    component: RequireAuth(PurchasedEventRedirect, {
      authType: AUTH_TYPE.EMAIL,
    }),
  },
];

export default routes;
